import { render } from "./AdmSearch.vue?vue&type=template&id=fa1deb38&scoped=true"
import script from "./AdmSearch.vue?vue&type=script&lang=js"
export * from "./AdmSearch.vue?vue&type=script&lang=js"

import "./AdmSearch.vue?vue&type=style&index=0&id=fa1deb38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1deb38"]])

export default __exports__